import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

const AUTH_ENTRY_PATHS = new Set(['login', 'register', 'auth-callback']);

@Injectable({ providedIn: 'root' })
export class AuthReturnUrlService {
  constructor(private readonly router: Router) {}

  loginUrlTree(returnUrl: string | null | undefined): UrlTree {
    const safeReturnUrl = this.getSafeReturnUrl(returnUrl);
    return this.router.createUrlTree(['/login'], safeReturnUrl ? { queryParams: { returnUrl: safeReturnUrl } } : {});
  }

  navigateIfPresent(returnUrl: string | null | undefined): boolean {
    const safeReturnUrl = this.getSafeReturnUrl(returnUrl);
    if (!safeReturnUrl) return false;
    void this.router.navigateByUrl(safeReturnUrl);
    return true;
  }

  isAuthEntryUrl(url: string | null | undefined): boolean {
    if (typeof url !== 'string' || !url.startsWith('/')) return false;
    try {
      const primary = this.router.parseUrl(url).root.children['primary'];
      return AUTH_ENTRY_PATHS.has(primary?.segments[0]?.path || '');
    } catch {
      return false;
    }
  }

  getSafeReturnUrl(returnUrl: string | null | undefined): string | null {
    if (typeof returnUrl !== 'string' || !returnUrl || !/^\/(?!\/)/.test(returnUrl) || /[\\\u0000-\u001F]/.test(returnUrl)) {
      return null;
    }

    let decoded: string;
    try {
      decoded = decodeURIComponent(returnUrl);
    } catch {
      return null;
    }
    if (!/^\/(?!\/)/.test(decoded) || /[\\\u0000-\u001F]/.test(decoded)) return null;

    try {
      const tree = this.router.parseUrl(returnUrl);
      const primary = tree.root.children['primary'];
      const firstSegment = primary?.segments[0]?.path || '';
      if (AUTH_ENTRY_PATHS.has(firstSegment)) return null;
      return this.router.serializeUrl(tree);
    } catch {
      return null;
    }
  }
}
